const CACHE_PREFIX = "wl_brand:";

/** Hosts that use default BluTec Ping branding without waiting for the API. */
const DEFAULT_PLATFORM_HOSTS = new Set([
  "localhost",
  "127.0.0.1",
  "pingplus.blutec.ai",
  "ping.blutec.ai",
]);

export function normalizeBrandHost(hostname) {
  return String(hostname || "")
    .trim()
    .toLowerCase()
    .replace(/^www\./, "");
}

export function isDefaultPlatformHost(hostname) {
  return DEFAULT_PLATFORM_HOSTS.has(normalizeBrandHost(hostname));
}

/**
 * Host sent to GET /api/white-label/public?host=
 * REACT_APP_WHITE_LABEL_HOST lets localhost dev simulate a partner domain.
 */
export function getWhiteLabelLookupHost() {
  const override = process.env.REACT_APP_WHITE_LABEL_HOST?.trim();
  if (override) return normalizeBrandHost(override);
  return normalizeBrandHost(window.location.hostname);
}

export function readBrandCache(hostname) {
  try {
    const key = normalizeBrandHost(hostname);
    const raw = sessionStorage.getItem(`${CACHE_PREFIX}${key}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeBrandCache(hostname, brand) {
  try {
    if (!brand?.id) return;
    const key = normalizeBrandHost(hostname);
    sessionStorage.setItem(`${CACHE_PREFIX}${key}`, JSON.stringify(brand));
  } catch {
    /* quota / private mode */
  }
}

export function clearBrandCache(hostname) {
  try {
    const key = normalizeBrandHost(hostname);
    sessionStorage.removeItem(`${CACHE_PREFIX}${key}`);
  } catch {
    /* ignore */
  }
}
